<!--
  @component
  Generates an SVG column chart.
 -->
<script>
	import { getContext } from 'svelte'

	const { data, xGet, yGet, x, yRange, xScale, y, height, zGet, zScale, z } =
		getContext('LayerCake')

	/** @type {String} [fill='#00e047'] - The shape's fill color. */
	export let fill = '#00e047'

	/** @type {String} [stroke='#000'] - The shape's stroke color. */
	export let stroke = '#000'

	/** @type {Number} [strokeWidth=0] - The shape's stroke width. */
	export let strokeWidth = 0

	export let hovered = null

	export let opacity = 0.3
	export let opacityHighlight = 1
	export let highlight = () => false

	$: columnWidth = (d) => {
		const vals = $xGet(d)
		return Math.abs(vals[1] - vals[0])
	}
</script>

<g class="column-group">
	{#each $data as d, i}
		{@const xGot = $xGet(d)}
		{@const xPos = Array.isArray(xGot) ? xGot[0] : xGot}
		{@const cWidth = $xScale.bandwidth ? $xScale.bandwidth() : columnWidth(d)}
		{@const yValue = $y(d)}
		{@const h = highlight(d, i)}
		{@const opacity = h ? opacityHighlight : opacity}
		<rect
			class="group-rect"
			data-id={i}
			data-range={$x(d)}
			data-count={yValue}
			x={xPos}
			y={Math.min($yGet(d), $yRange[0])}
			width={cWidth}
			height={Math.abs($yRange[0] - $yGet(d))}
			opacity={hovered
				? d === hovered
					? opacityHighlight
					: opacity
				: h
					? opacityHighlight
					: opacity}
			{fill}
			{stroke}
			stroke-width={strokeWidth} />
	{/each}
</g>

<style>
</style>
